import { memo } from "react";

import FluxZapQuickActionsPanel from "src-next/modules/crm-clinical/management/components/FluxZapQuickActionsPanel";

/**
 * Acesso rápido FluxZap na agenda (cards padrão + diálogos CRM).
 */
const ScheduleFluxZapShortcutsPanel = memo(() => {
  return <FluxZapQuickActionsPanel context="schedule" cardSize="default" />;
});

ScheduleFluxZapShortcutsPanel.displayName = "ScheduleFluxZapShortcutsPanel";

export default ScheduleFluxZapShortcutsPanel;
